import React, { useEffect, useState } from "react";

import { Dialog } from "primereact/dialog";

import DocumentView from "./DocumentView";


const FileDisplay = (props) => {
    const [selectedFile, setSelectedFile] = useState(null)
    const [uploadedFileView, setUploadedFileView] = useState(false)
    const [textContent, setTextContent] = useState("")

    useEffect(() => {
        if(["txt".includes(props.type)]){
            fetch(props.url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch file")
                }
                return response.text()
            })
            .then((text) => setTextContent(text))
            .catch((error) => console.error(error))
        }
    }, [props.url])

    const handleFileClick = (fileUrl) => {
        setSelectedFile(fileUrl)
        setUploadedFileView(true)
    }
    
    if(["jpg", "jpeg", "png"].includes(props.type)) {
        return (
            <>
                {/* <img src={props.url} style={{height: "200px"}} className="img-in-comment" alt="Image preview" onClick={() => handleFileClick(props.url)} /> */}
                <div className="expand-container" style={{ height :"200px", width: "fit-content"}}>
                    <img src={props.url} style={{height: "100%"}} className="img-in-comment" alt="Image preview"/>
                    <div className="expand-icon" onClick={() => handleFileClick(props.url)} style={{ right: "10px"}}>
                        <i className="fa-solid fa-expand" style={{ fontSize: "17px"}}></i>
                    </div>
                </div>
                { uploadedFileView && 
                    <Dialog visible={uploadedFileView} style={{ width: '85vw', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setUploadedFileView(false)}>
                        <DocumentView fileUrl={selectedFile} showZoomControl={true} />
                    </Dialog>
                }
            </>
        )
    }

    if(["pdf"].includes(props.type)){
        return (
            <>
                {/* <a rel="noopener noreferrer" onClick={() => handleFileClick(props.url)}>
                    <div className="">
                        <embed src={props.url} className="doc-in-comment" type="application/pdf" style={{ cursor: 'pointer', height: "200px" }}/>
                    </div>
                </a> */}
                <div className="expand-container">
                    <embed src={props.url} className="doc-in-comment" type="application/pdf" style={{ cursor: 'pointer', height: "200px", width: "100%" }}/>
                    <div className="expand-icon" onClick={() => handleFileClick(props.url)}>
                        <i className="fa-solid fa-expand" style={{ fontSize: "17px"}}></i>
                    </div>
                </div>
                { uploadedFileView && 
                    <Dialog visible={uploadedFileView} style={{ width: '85vw', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setUploadedFileView(false)}>
                        <DocumentView fileUrl={selectedFile} showZoomControl={true} />
                    </Dialog>
                }
            </>
        )
    }

    if(["txt"].includes(props.type)){
        return (
            <div>
                <pre style={{ maxWidth: "800px", maxHeight: "400px", minHeight: "50px", padding: "8px", overflow: "auto", backgroundColor: "black", color: "white", fontSize: "12px" }}>
                    {textContent}
                </pre>
            </div>
        )
    }
}

export default FileDisplay;